export function isPageContext(): boolean {
	return globalThis.location === globalThis.parent.location;
}
